import { render, staticRenderFns } from "./CadastroRegulamento.vue?vue&type=template&id=4b5c3261&scoped=true&"
import script from "./CadastroRegulamento.vue?vue&type=script&lang=js&"
export * from "./CadastroRegulamento.vue?vue&type=script&lang=js&"
import style0 from "./CadastroRegulamento.vue?vue&type=style&index=0&id=4b5c3261&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5c3261",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
